/**
 * A file of general helper functions to import throughout the React program.
 */

/**
 * Recieves a string and removes the whitespace using .trim().
 * @param {*} args
 * @returns String
 */
export function removeWhiteSpace(args) {
    try {
        if (typeof args === 'string') return args.trim();
    } catch (e) {
        console.error(e.name);
        console.error(e.message);
    }
}

/**
 * Calls the removeWhiteSpace helper function on an argument.
 * Checks if the string length is 0. If it is, the string is empty, and will return true.
 * @param {*} args
 * @returns Boolean
 */
export function isEmpty(args) {
    const temp = removeWhiteSpace(args);

    try {
        if (temp.length === 0) return true;
        return false;
    } catch (e) {
        console.error(e.name);
        console.error(e.message);
    }
}

/**
 * Checks if an Array is empty.
 * Returns boolean true if it is.
 * @param {*} keywordArr
 * @returns Boolean
 */
export function noKeywordsCheck(keywordArr) {
    try {
        if (keywordArr.length !== 0) return false
        return true
    } catch (e) {
        console.error(e.name);
        console.error(e.message);
    }
}

/**
 * Takes in a string and an Array.
 * Appends the string to the Array and returns the new Array.
 * @param {*} input
 * @returns Array
 */
export function appendInputArr(input, keywordArr) {
    let newInputArr = keywordArr.concat(input);
    return newInputArr;
}

/**
 * Takes in two Arrays of Strings.
 * The values between the two arguments are compared, and if there are matches, the matched Strings are 'Flagged'.
 * 'Flagged' values are turned into an Array within the Array maintaining the String value, and a String value of 'Flagged'.
 * @param {*} currentKeywords
 * @param {*} badKeywords
 * @returns
 */
export function flagBadKeywords (currentKeywords, badKeywords){
    let tempArr = currentKeywords;

    for (const badKeyword of badKeywords){
        let indexFind = currentKeywords.findIndex(keyword => keyword === badKeyword);
        tempArr[indexFind] = [badKeyword, 'Flagged'];
    }

    return tempArr;
}

/**
 * Takes in an Array of current Keywords (flagged Keywords included) and a Boolean.
 * If the Database was changed, the function will strip away the 'Flagged' aspect and turn it back into a string.
 * If the Database wasn't changed, the function will remove the 'Flagged' values from the Array.
 * @param {*} keywordState
 * @param {*} databaseChangeState
 * @returns An Array of Strings
 */
export function filterBadKeywords (keywordState, databaseChangeState){
    let filteredKeywords = [];

    if (databaseChangeState) keywordState.map(keyword => (Array.isArray(keyword) ? filteredKeywords.push(keyword[0]) : filteredKeywords.push(keyword)));
    else keywordState.map(keyword => (Array.isArray(keyword) ? null : filteredKeywords.push(keyword)));

    return filteredKeywords;
}


/**
 * Takes in a string, and the max length you want the string to have before it's replaced with '...'
 * @param {*} string
 * @param {*} charLength
 * @returns A truncated string.
 */
export function truncateString(string, charLength) {
    if (string.length > charLength) {
       return string.substring(0, charLength) + '...';
    }
    return string;
 };

 /**
  * Takes in the input string and compares its length to the maxLength parameter.
  * @param {*} string
  * @param {*} maxLength
  * @returns boolean
  */
 export function maxCharLengthCheck(string, maxLength) {
    if(string.length > maxLength) return false
    return true
 }

 /**
  * Fetches the data for an associated cookie (if it exists).
  * @param {*} name
  * @returns string
  */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}